<template>
  <v-popover
    :auto-hide="true"
    :class="[context]"
    :container="'#root .router-view'"
    :offset="24"
    :open="popoverOpen"
    :placement="'auto'"
    :popover-class="['share-popover', context]"
    :trigger="'manual'"
    @hide="handlePopoverHide"
  >
    <button
      class="share-component-container"
      @click="triggerShare"
    >
      <icon
        name="share"
        :variant="iconVariant"
      />
      {{ shareText }}
    </button>
    <template v-slot:popover>
      <div class="heading">
        {{ popoverTitle }}
      </div>
      <div class="subheading">
        {{ popoverDescription }}
      </div>
      <share-box :url="url" />
    </template>
  </v-popover>
</template>

<script>
import Icon from '@components/singletons/icon';
import ShareBox from '@components/share/shareBox';

export default {
  components: { Icon, ShareBox },
  props: {
    category: {
      type: Object,
    },
    context: {
      type: String,
    },
    flashcard: {
      type: Object,
    },
    popoverDescription: {
      type: String,
    },
    popoverTitle: {
      type: String,
    },
    shareMessage: {
      type: String,
    },
    shareText: {
      type: String,
      default: 'SHARE',
    },
    url: {
      type: String,
    },
  },
  data() {
    return {
      iconVariant: '',
      popoverOpen: false,
    };
  },
  computed: {
    analyticsParams() {
      let data = {};

      if (this.context === 'home') {
        data['Location'] = 'Refer Message';
      } else if (this.context === 'social') {
        data['Location'] = 'Social Proof';
      } else {
        data = {
          'Asset ID': this.flashcard?.id,
          'Asset Title': this.flashcard?.question,
          'Asset Type': 'Question',
          'Category ID': this.category?.id,
          'Category Name': this.category?.name,
        };

        if (this.context === 'rationale') {
          data['Location'] = 'Question Explanation';
        } else if (this.context === 'header') {
          data['Location'] = 'Question Header';
        } else {
          data['Location'] = 'Question Footer';
        }
      }

      return data;
    },
  },
  methods: {
    handlePopoverHide() {
      this.popoverOpen = false;
      this.toggleIconVariant(false);
    },
    sendAnalyticsEvents() {
    },
    toggleIconVariant(show) {
      const variant = show ? '000000' : '';
      this.iconVariant = variant;
    },
    triggerShare() {
      this.toggleIconVariant(true);

      if (navigator.share) {
        this.$analytics.events.sharedAsset(this.analyticsParams);
        navigator.share({
          text: this.shareMessage,
          url: this.url,
        }).catch(e => {
          if (e?.status === 'rejected') {
            this.popoverOpen = true;
          }
        });
      } else {
        this.popoverOpen = true;
        this.$analytics.events.copiedShareLink(this.analyticsParams);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.v-popover {

  .share-component-container {
    align-items: center;
    background: transparent;
    display: flex;
    font-size: rem-calc(12);
    font-weight: $semi-bold;

    img {
      height: rem-calc(20);
      margin-right: rem-calc(8);
      width: rem-calc(20);
    }
  }

  &.header {
    display: none;
    flex-shrink: 0;
    margin-left: auto;

    @include breakpoint(medium) {
      display: block;
    }

    @include breakpoint(small) {
      display: block;
    }
  }

  &.footer {
    margin-left: rem-calc(4);

    @include breakpoint(medium) {
      display: none;
    }

    @include breakpoint(small) {
      display: none;
    }
  }

  &.rationale {
    display: none;
    margin-bottom: rem-calc(12);
    margin-top: rem-calc(28);
    text-align: center;

    @include breakpoint(medium) {
      display: block;
    }

    @include breakpoint(small) {
      display: block;
    }

    .share-component-container {
      border: 1px solid black;
      border-radius: 4px;
      padding: rem-calc(8) rem-calc(16);
    }
  }
}
</style>

<style lang='scss'>
.share-popover.tooltip {
  max-width: rem-calc(400);

  // these handle when the tooltip is opened and screen size changes
  &.header, &.rationale {
    display: none !important;

    @include breakpoint(medium) {
      display: block !important;
    }

    @include breakpoint(small) {
      display: block !important;
    }
  }

  &.footer {
    @include breakpoint(medium) {
      display: none !important;
    }

    @include breakpoint(small) {
      display: none !important;
    }
  }

  .wrapper {
    .tooltip-inner {
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
      color: black;
      padding: rem-calc(24);

      .heading {
        font-weight: $semi-bold;
        margin-bottom: rem-calc(8);
      }

      .subheading {
        color: #767676;
        font-size: rem-calc(14);
        letter-spacing: -0.5px;
        margin-bottom: rem-calc(20);
      }
    }

    .tooltip-arrow.popover-arrow {
      display: none;
    }
  }
}
</style>
